import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { errMsg } from "@/lib/api";

export function PixKeyForm({ value, onSave }) {
  const [pix, setPix] = useState(value || "");
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await onSave(pix.trim()); toast.success("Chave Pix salva"); } catch (er) { toast.error(errMsg(er)); }
    setBusy(false);
  };
  return (
    <form onSubmit={save} className="card-surface space-y-3 p-5" data-testid="referral-pix-form">
      <p className="eyebrow flex items-center gap-1.5"><KeyRound className="h-3.5 w-3.5" />Chave Pix para receber</p>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Input value={pix} onChange={(e) => setPix(e.target.value)} placeholder="CPF, CNPJ, celular, e-mail ou chave aleatória" maxLength={140} data-testid="referral-pix-input" />
        <Button type="submit" disabled={busy || pix.trim().length < 3} data-testid="referral-pix-save-btn">{busy ? "Salvando..." : "Salvar"}</Button>
      </div>
      {!value && <p className="text-xs text-amber-600 dark:text-amber-400" data-testid="referral-pix-missing">Cadastre sua chave Pix para receber as comissões.</p>}
    </form>
  );
}
